//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import manba from 'manba'
import { axiosGet } from '../../../../axios/axios.js'

const DATE_TIME_FORMAT = 'DD-MM-YYYY hh:mm'
const parseDate = function (value) {
  const pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2})/
  return new Date(value.replace(pattern, '$3-$2-$1T$4:$5:00'))
}

export default {
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    t1period: function () {
      if (this.resultValue.value && this.resultValue.value.tperiods && this.resultValue.value.tperiods.length) {
        return this.resultValue.value.tperiods[0]
      } else {
        return null
      }
    },
    t2period: function () {
      if (this.resultValue.value && this.resultValue.value.tperiods && this.resultValue.value.tperiods.length) {
        return this.resultValue.value.tperiods[1]
      } else {
        return null
      }
    },
    t3period: function () {
      if (this.resultValue.value && this.resultValue.value.tperiods && this.resultValue.value.tperiods.length) {
        return this.resultValue.value.tperiods[2]
      } else {
        return null
      }
    }
  },
  watch: {
    t1period: function (result) {
      if (this.resultValue.value.isGeneralTperiods) {
        for (let i = 0; i < this.resultValue.value.directions.length; i++) {
          this.resultValue.value.directions[i].tperiods[0] = result
        }
      }
    },
    t2period: function (result) {
      if (this.resultValue.value.isGeneralTperiods) {
        for (let i = 0; i < this.resultValue.value.directions.length; i++) {
          this.resultValue.value.directions[i].tperiods[1] = result
        }
      }
    },
    t3period: function (result) {
      if (this.resultValue.value.isGeneralTperiods) {
        for (let i = 0; i < this.resultValue.value.directions.length; i++) {
          this.resultValue.value.directions[i].tperiods[2] = result
        }
      }
    }
  },
  created: function () {
    // Загрузка данных по количеству и названию направлений из Инвенто
    if (this.serviceObject.number && this.isAuditDataEmpty() && this.isInventoDirectionsNameEmpty()) {
      this.loadInventoDirections()
    }
  },
  methods: {
    onAddDirection: function (inventoName, auditdata) {
      return this.resultValue.onAddDirection(inventoName, auditdata)
    },
    onDeleteDirection: function () {
      this.resultValue.value.directions.pop()
    },
    isAuditDataEmpty: function () {
      // Нет заполненных данных аудита
      for (let i = 0; i < this.resultValue.value.directions.length; i++) {
        for (let j = 0; j < this.resultValue.value.directions[i].audit.data.length; j++) {
          if (this.resultValue.value.directions[i].audit.data[j]) {
            return false
          }
        }
      }
      return true
    },
    isInventoDirectionsNameEmpty: function () {
      // Нет названий направлений из Инвенто
      for (let i = 0; i < this.resultValue.value.directions.length; i++) {
        if (this.resultValue.value.directions[i].invento.name) {
          return false
        }
      }
      return true
    },
    getCoefficient: function (dirIndex, tIndex) {
      if (
        this.resultValue.value.directions[dirIndex].audit.data[tIndex] &&
        this.resultValue.value.directions[dirIndex].invento.data[tIndex] &&
        this.resultValue.value.directions[dirIndex].invento.data[tIndex] > 0
      ) {
        return Math.round((this.resultValue.value.directions[dirIndex].audit.data[tIndex] / this.resultValue.value.directions[dirIndex].invento.data[tIndex]) * 100) + '%'
      } else {
        return null
      }
    },
    getAverageCoefficient: function (dirIndex) {
      let numerator = 0
      let denominator = 0
      for (let tIndex = 0; tIndex < 3; tIndex++) {
        if (this.getCoefficient(dirIndex, tIndex)) {
          numerator += this.resultValue.value.directions[dirIndex].audit.data[tIndex]
          denominator += this.resultValue.value.directions[dirIndex].invento.data[tIndex]
        }
      }
      if (denominator !== 0) {
        return Math.round(numerator / denominator * 1000) / 10 + '%'
      } else {
        return null
      }
    },
    tperiodSelected: function (dirIndex, tIndex) {
      // Автоматический сдвиг на 5 мин в интервалах
      if (dirIndex === -1) {
        if (tIndex === 0 && this.resultValue.value.tperiods[tIndex] && this.resultValue.value.tperiods[tIndex].length === DATE_TIME_FORMAT.length) {
          const date = parseDate(this.resultValue.value.tperiods[tIndex])

          date.setMinutes(date.getMinutes() + 5)
          this.resultValue.value.tperiods[1] = manba(new Date(date)).format(DATE_TIME_FORMAT)

          date.setMinutes(date.getMinutes() + 5)
          this.resultValue.value.tperiods[2] = manba(new Date(date)).format(DATE_TIME_FORMAT)
        }
      } else {
        if (tIndex === 0 && this.resultValue.value.directions[dirIndex].tperiods[tIndex] && this.resultValue.value.directions[dirIndex].tperiods[tIndex].length === DATE_TIME_FORMAT.length) {
          const date = parseDate(this.resultValue.value.directions[dirIndex].tperiods[tIndex])

          date.setMinutes(date.getMinutes() + 5)
          this.resultValue.value.directions[dirIndex].tperiods[1] = manba(new Date(date)).format(DATE_TIME_FORMAT)

          date.setMinutes(date.getMinutes() + 5)
          this.resultValue.value.directions[dirIndex].tperiods[2] = manba(new Date(date)).format(DATE_TIME_FORMAT)
        }
      }
    },
    disableUpdateButton: function (dirIndex) {
      let tperiodsEmpty = true

      if (this.resultValue.value.directions && this.resultValue.value.directions.length && this.resultValue.value.directions[dirIndex]) {
        for (let i = 0; i < this.resultValue.value.directions[dirIndex].tperiods.length; i++) {
          if (this.resultValue.value.directions[dirIndex].tperiods[i]) {
            tperiodsEmpty = false
            break
          }
        }
      }
      return tperiodsEmpty
    },
    onUpdateInventoData: function (dirIndex) {
      for (let j = 0; j < this.resultValue.value.directions[dirIndex].tperiods.length; j++) {
        if (this.resultValue.value.directions[dirIndex].tperiods[j]) {
          this.loadInventoData(dirIndex, parseDate(this.resultValue.value.directions[dirIndex].tperiods[j]), j)
        }
      }
    },
    loadInventoData: function (dirIndex, date, tIndex) {
      this.resultValue.value.directions[dirIndex].loading = true
      let startTime = null
      let endTime = null
      if (date) {
        date.setMinutes(date.getMinutes() - 1)
        startTime = date.getTime()
        date.setMinutes(date.getMinutes() + 2)
        endTime = date.getTime()
      }
      return axiosGet({
        url: '/reportdata/detpolldatainterval?number=' + this.serviceObject.number +
          (startTime ? '&startTime=' + startTime : '') +
          (endTime ? '&endTime=' + endTime : ''),
        onSuccess: (response) => {
          if (response.data && response.data[dirIndex]) {
            if (response.data[dirIndex].points[0]) {
              this.$set(this.resultValue.value.directions[dirIndex].invento.data, tIndex, response.data[dirIndex].points[0].value / 12)
              if (response.data[dirIndex].name) {
                this.$set(this.resultValue.value.directions[dirIndex].invento, 'name', response.data[dirIndex].name)
              }
            } else {
              this.$set(this.resultValue.value.directions[dirIndex].invento.data, tIndex, 'Нет данных')

              this.$q.notify({
                type: 'warning',
                message: 'Данные c детектора отсутствуют',
                progress: true,
                timeout: 8000
              })
            }
          } else {
            this.$q.notify({
              type: 'warning',
              message: 'Данное направление отсутствует',
              progress: true,
              timeout: 8000
            })
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка загрузки данных c детектора',
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.resultValue.value.directions[dirIndex].loading = false
      })
    },
    loadInventoDirections: function () {
      this.loading = true
      let startTime = null
      let endTime = null
      const date = new Date()
      if (date) {
        date.setMinutes(date.getMinutes() - 1)
        startTime = date.getTime()
        date.setMinutes(date.getMinutes() + 2)
        endTime = date.getTime()
      }
      return axiosGet({
        url: '/reportdata/detpolldatainterval?number=' + this.serviceObject.number +
          (startTime ? '&startTime=' + startTime : '') +
          (endTime ? '&endTime=' + endTime : ''),
        onSuccess: (response) => {
          if (response.data) {
            this.resultValue.value.directions = []
            for (let i = 0; i < response.data.length; i++) {
              this.onAddDirection(response.data[i].name, null)
            }
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка загрузки данных по направлениям c детектора',
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

